import React from 'react'

export const ReorganizeIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width='24' height='72' viewBox='0 0 24 72' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17 12.5L12 7.5L7 12.5'
        stroke='#B0B0B0'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g clipPath='url(#clip0_17626_51090)'>
        <path
          d='M9 30C9.55228 30 10 29.5523 10 29C10 28.4477 9.55228 28 9 28C8.44772 28 8 28.4477 8 29C8 29.5523 8.44772 30 9 30Z'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9 37C9.55228 37 10 36.5523 10 36C10 35.4477 9.55228 35 9 35C8.44772 35 8 35.4477 8 36C8 36.5523 8.44772 37 9 37Z'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9 44C9.55228 44 10 43.5523 10 43C10 42.4477 9.55228 42 9 42C8.44772 42 8 42.4477 8 43C8 43.5523 8.44772 44 9 44Z'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15 30C15.5523 30 16 29.5523 16 29C16 28.4477 15.5523 28 15 28C14.4477 28 14 28.4477 14 29C14 29.5523 14.4477 30 15 30Z'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15 37C15.5523 37 16 36.5523 16 36C16 35.4477 15.5523 35 15 35C14.4477 35 14 35.4477 14 36C14 36.5523 14.4477 37 15 37Z'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15 44C15.5523 44 16 43.5523 16 43C16 42.4477 15.5523 42 15 42C14.4477 42 14 42.4477 14 43C14 43.5523 14.4477 44 15 44Z'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <path
        d='M7 59.5L12 64.5L17 59.5'
        stroke='#B0B0B0'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <clipPath id='clip0_17626_51090'>
          <rect width='24' height='24' fill='white' transform='translate(0 24)' />
        </clipPath>
      </defs>
    </svg>
  )
}
